<template>
  <div id="page">
    <img
      :src="images.top"
      style="width: 100%; float: center; margin-top: 40px"
    />
    <div style="margin: 18px 60px 0 60px;">
     <b v-if="page < 3">2、综合能力评价</b>
    </div>
    <div
      style="
        margin: 20px 70px;
        line-height: 23px;
        color: #444444;
      "
    >
      <table
        width="480"
        height="89"
        border="1"
        cellpadding="0"
        cellspacing="0"
        style="width: 653px"
      >
        <tbody>
          <tr v-if="page == 2">
            <td
              style="
                text-align: center;
                background-color: #3f3e66;
                color: white;
                height: 50px;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <img
                :src="images.youshi"
                style="width: 20px; height: 18px; margin-right: 5px"
              />
              优势项
            </td>
          </tr>
          <tr v-if="page == 2">
            <td class="et2">
              <span v-if="this.advantage.length == 0"> 暂无结果 </span>
              <span v-else>
               <ul>
                 <li v-for="(i, ll) in advantage.split(/\n/)" :key="ll">
                   {{ i }}
                 </li>
               </ul>
              </span>
            </td>
          </tr>
          <tr v-if="page == 2">
            <td
              style="
                text-align: center;
                background-color: #3f3e66;
                color: white;
                height: 50px;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <img :src="images.huojian" style="width: 18px; height: 18px;" />
               &nbsp;待发展项
            </td>
          </tr>
          <tr v-if="page == 2">
            <td class="et2">
              <span v-if="this.toBeDeveloped.length == 0"> 暂无结果 </span>
              <span v-else>
               <ul>
                 <li v-for="(i, ll) in this.toBeDeveloped.split(/\n/)" :key="ll">
                   {{ i }}
                 </li>
               </ul>
              </span>
            </td>
          </tr>
          <tr v-if="page == 3">
            <td
              style="
                text-align: center;
                background-color: #3f3e66;
                color: white;
                height: 50px;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
               <img :src="images.development" style="width: 18px; height: 18px;" />
               &nbsp;发展建议
            </td>
          </tr>
          <tr v-if="page == 3">
            <td class="et2">
              <span v-if="this.managementSuggestions.length == 0"> 暂无结果 </span>
              <span v-else>
               <ul>
                 <li v-for="(i, ll) in this.managementSuggestions.split(/\n/)" :key="ll">
                   {{ i }}
                 </li>
               </ul>
              </span>
            </td>
          </tr>
          <tr v-if="page == 3">
            <td
              style="
                text-align: center;
                background-color: #3f3e66;
                color: white;
                height: 50px;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
               <img :src="images.study" style="width: 18px; height: 18px;" />
               &nbsp;个人学习建议
            </td>
          </tr>
          <tr v-if="page == 3">
            <td class="et2">
              <span v-if="this.LearningSuggestions.length == 0"> 暂无结果 </span>
              <span v-else>
               <ul>
                 <li v-for="(i, ll) in this.LearningSuggestions.split(/\n/)" :key="ll">
                   {{ i }}
                 </li>
               </ul>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div id="footer">
      <span
       id="footer-red"
        >{{ page }}</span
      >
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "model",
    "managementSuggestions",
    "toBeDeveloped",
    "advantage",
    "IsOutside",
    "LearningSuggestions",
    "page"
  ],
  data() {
    return {
      id:"",
      images: {
        top: require("@/views/CNBMTalent/images/top.jpg"),
        youshi: require("@/views/CNBM/images/youshi.png"),
        huojian: require("@/views/CNBM/images/huojian.png"),
        development: require("@/views/CNBMTalent/images/development.png"),
        study: require("@/views/CNBMTalent/images/study.png"),
      },
      litunanAdvantage:[{
        value : "年轻有活力，可以快速适应新环境；执行力强，能够在短期内了解业务并抓住工作重点；",
      },{
        value : "对于凯盛目前所面临的战略转变有足够的认识，有一定战略视野，对于如何开展未来的财务工作有清晰的思路；",
      },{
        value : "能认识到凯盛因为快速扩张所导致的财务管理方面的不足，能够制定并实施相应的解决方案。",
      }
    
    ],
     
      litunanToBeDeveloped:[{
        value : "需要继续加深对于当前业务的了解，利用自身专业优势促进和打造业财融合的财务团队，发挥更大作用。"
      }]
       
      
      
     
    };
  },
  mounted() {
    this.id = this.getUrlParam("id");
    console.log(this.advantage,this.toBeDeveloped)
    
  },
  watch: {},
  methods: {
      //获取url的
      getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
      var r = window.location.search.substr(1).match(reg); //匹配目标参数
      if (r != null) return unescape(r[2]);
      return null; //返回参数值
    },
  },
};
</script>
<style lang='scss' scoped>

  li {
    padding: 5px 0;
  }
  .title-info {
    font-size: 22px;
    font-weight: bold;
    margin: 30px 60px 0 60px;
  }

  .box-block {
    display: table;
    width: 100%;
    border-spacing: 10px 5px; /* 水平间距 垂直间距 */
    padding: 30px 30px 0 30px;
  }

  .box-block div {
    display: table-cell;
    word-wrap: break-word;
    width: 33.33%;
    text-align: center;
    padding: 10px;
  }
  .box-block ul {
    text-align: left;
    padding: 10px;
  }
  .box1 {
    border: 2px solid #4288d5;
  }

  .box2 {
    border: 2px solid #4288d5;
  }

  .box-block2 {
    display: table;
    width: 100%;
    border-spacing: 10px 5px; /* 水平间距 垂直间距 */
    padding: 0 30px 30px 30px;
  }
  .box-block2 div {
    display: table-cell;
    word-wrap: break-word;
    width: 33.33%;
    text-align: center;
    padding: 10px;
  }
  .box3 {
    border: 2px solid #4288d5;
  }
  .box-block2 ul {
    padding: 10px;
    text-align: left;
  }
  #footer {
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: 60px; /*脚部的高度*/
    text-align: center;
    clear: both;
  }

ul li::marker {
  font-size: 25px;
}
</style>



// WEBPACK FOOTER //
// src/views/CNBMTalent/pages/page-three.vue